"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareButtons = void 0;
const react_1 = __importDefault(require("react"));
const store_1 = require("../../../../store");
const react_i18next_1 = require("react-i18next");
const ShareButtons = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const chatbotName = (0, store_1.useStoreState)((state) => state.chatbot.value.name);
    const nav = navigator;
    const mobileShareAvailable = nav.share;
    const handleMobileShareClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield nav.share({
                title: `${chatbotName} - Typebot`,
                text: t("I invite you to discuss"),
                url: window.location.href,
            });
        }
        catch (e) {
            console.log(e);
        }
    });
    return (react_1.default.createElement("div", { className: "flex flex-row mt-2 items-start w-full lg:w-4/5" },
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("div", { className: "flex flex-row flex-wrap mb-2 mr-2" }, mobileShareAvailable ? (react_1.default.createElement("button", { className: "flex items-center px-6 py-2 rounded-md transition-all filter hover:brightness-90 active:brightness-75 duration-100 focus:outline-none mr-2 mb-2 typebot-button active", onClick: handleMobileShareClick }, t("Share"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("a", { href: `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, target: "_blank", className: "flex items-center px-6 py-2 rounded-md transition-all filter hover:brightness-90 active:brightness-75 duration-100 focus:outline-none mr-2 mb-2 typebot-button active", rel: "noreferrer" }, "Facebook"),
                react_1.default.createElement("a", { href: `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`, target: "_blank", className: "flex items-center px-6 py-2 rounded-md transition-all filter hover:brightness-90 active:brightness-75 duration-100 focus:outline-none mr-2 mb-2 typebot-button active", rel: "noreferrer" }, "LinkedIn"),
                react_1.default.createElement("a", { href: `https://twitter.com/intent/tweet?text=${window.location.href}`, target: "_blank", className: "flex items-center px-6 py-2 rounded-md transition-all filter hover:brightness-90 active:brightness-75 duration-100 focus:outline-none mr-2 mb-2 typebot-button active", rel: "noreferrer" }, "Twitter")))))));
};
exports.ShareButtons = ShareButtons;
//# sourceMappingURL=ShareButton.js.map